// Shared labels/formatters for the Renewals register and its detail sheet.
export const STATUS_META = {
  overdue: { label: "Overdue", cls: "bg-rose-50 text-rose-700 border-rose-200", dot: "bg-rose-500" },
  due_soon: { label: "Due soon", cls: "bg-amber-50 text-amber-700 border-amber-200", dot: "bg-amber-500" },
  upcoming: { label: "Upcoming", cls: "bg-sand-100 text-ink/70 border-sand-200", dot: "bg-sand-400" },
};
export const RECURRENCE_LABELS = {
  monthly: "Every month", quarterly: "Every quarter", semiannual: "Twice a year",
  annual: "Every year", biennial: "Every 2 years", triennial: "Every 3 years", once: "One-off",
};
export const OVERDUE_CHOICES = [[0, "once only"], [3, "every 3 days"], [7, "weekly"], [14, "every 2 weeks"], [30, "monthly"]];
export const overdueLabel = (n) => (OVERDUE_CHOICES.find(([v]) => v === Number(n))?.[1]) || `every ${n} days`;
export const vendorText = (v) => v && [v.company, v.contact_name, v.phone, v.email, v.account_number ? `acct #${v.account_number}` : ""].filter(Boolean).join(" · ");
const inDays = (n) => (n === 0 ? "today" : `in ${n} day${n === 1 ? "" : "s"}`);
export const nextReminderText = (i) => {
  const n = i.next_reminder;
  if (!n) return "";
  if (n.kind === "overdue") {
    if (!n.sent) return `Overdue alert today → ${n.to}`;
    if (n.every > 0) return `Overdue alert sent → ${n.to} · again ${inDays(n.in_days)} (${overdueLabel(n.every)})`;
    return `Overdue alert sent → ${n.to}`;
  }
  if (n.kind === "lead") return `Next reminder ${inDays(n.in_days)} (${n.rung}-day mark) → ${n.to}`;
  return `All lead reminders sent · overdue alert if not filed by ${i.due_on} → ${n.to}`;
};
export const when = (i) => i.status === "overdue"
  ? `was due ${i.due_on} · ${Math.abs(i.days_out)} day${Math.abs(i.days_out) === 1 ? "" : "s"} ago`
  : `${i.due_on} · in ${i.days_out} day${i.days_out === 1 ? "" : "s"}`;
export const fmtStamp = (iso) => { try { return new Date(iso).toLocaleString([], { month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit" }); } catch { return iso || ""; } };

// "Who gets notified" — the resolved recipient set for a renewal item (n = item.notify).
export const CHAN_WORD = { bell: "bell", email: "email", sms: "text" };
export const chanText = (r) => (r.channels || []).map((c) => CHAN_WORD[c] || c).join(" + ");
// Staff first, then outside addresses — one flat list so the card and the sheet can't disagree.
const notifyNames = (n) => [...(n.recipients || []).map((r) => r.name), ...(n.externals || []).map((e) => e.email)];
export const notifyLabel = (n) => {
  if (!n) return "";
  if (!n.count) return "No one is set to be notified";
  const names = notifyNames(n);
  if (n.count === 1) {
    const one = (n.recipients || [])[0];
    return `Notifies ${names[0]} · ${one ? chanText(one) : "email"}`;
  }
  return `Notifies ${names[0]} + ${n.count - 1} more`;
};
// The card only has room for "Jane + 2 more"; the detail sheet names everyone, so it needs the
// rule above the list too — otherwise "3 recipients" doesn't explain WHY it's those three.
export const notifyScopeText = (n) => {
  if (!n) return "";
  const base = n.scope === "owner" ? `Only the owner${n.owner_name ? `, ${n.owner_name}` : ""}` : "Everyone on the management team";
  const who = n.mode === "only" ? "Only the people picked on this obligation"
    : n.mode === "also" ? `${base}, plus the people picked on this obligation`
      : base;
  if (!n.count) return `${who} — but nobody has reminders switched on`;
  return `${who} — ${n.count} ${n.count === 1 ? "recipient" : "recipients"}`;
};
